export const hasUpper = /\p{Lu}/u
export const hasLower = /\p{Ll}/u

export const hasDigitOrSpecialCharacter = /[0-9!"#$%&'()*+,./:;<=>?@[\]^_`{}~\\\-|\s]/u
